// PWA push мэдэгдэл: асаах / унтраах / төлөв. Service worker (/sw.js) бүртгэлтэй байх ёстой (production).
// iPhone: зөвхөн "Add to Home Screen"-ээр суулгасан апп дотор (iOS 16.4+) ажиллана.
import { instance } from "utils/axios";

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

async function registration() {
  return (await navigator.serviceWorker.getRegistration()) || navigator.serviceWorker.register("/sw.js");
}

// "on" | "off" | "denied" | "unsupported"
export async function pushState() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub ? "on" : "off";
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Энэ төхөөрөмж мэдэгдэл дэмжихгүй");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Мэдэгдлийн зөвшөөрөл өгөөгүй");
  const { data } = await instance({ method: "get", url: "/push/key" });
  const reg = await registration();
  await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.publicKey) }));
  await instance({ method: "post", url: "/push/subscribe", data: { subscription: sub.toJSON() }, noMessage: true });
  return "on";
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    await instance({ method: "post", url: "/push/unsubscribe", data: { endpoint: sub.endpoint }, noMessage: true }).catch(() => {});
    await sub.unsubscribe();
  }
  return "off";
}

export const testPush = () => instance({ method: "post", url: "/push/test", noMessage: true });
